module.exports = __webpack_public_path__ + "static/media/fantest_yps_2.ba3716a1.png";